// src/hooks/useSendTimings.js
// The sending timings as words (3.75.0, Settings → Fax Settings → Sending
// Timings), for screens that quote them: "15 to 30 minutes" apart for a
// Hard to reach number, retries, the block. One request, kept for 5 minutes
// per browser tab; the standard wording until it arrives.
import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { fetchSendTimings } from '../utils/api';

// 3.77.2: the owner's timings became the standard (lib/sendTimings.js)
export const STANDARD_TEXT = { hardSpacing: '15 to 30 minutes', retryFirst: '10 minutes', retries: 1, retriesWord: 'once', priorityRetries: 2, guardFailures: 6, blockLimit: 5, blockHours: 24, blockFor: '24 hours' };
let cache = null;   // { at, text }
export function forgetSendTimings() { cache = null; }
export function rememberSendTimings(text) { cache = { at: Date.now(), text: { ...STANDARD_TEXT, ...text } }; }

export function useSendTimings() {
  const { getToken } = useAuth();
  const [text, setText] = useState(cache ? cache.text : STANDARD_TEXT);
  useEffect(() => {
    if (cache && Date.now() - cache.at < 5 * 60000) { setText(cache.text); return; }
    let gone = false;
    fetchSendTimings(getToken).then(j => {
      if (gone || !j?.text) return;
      rememberSendTimings(j.text);
      setText(cache.text);
    }).catch(() => { /* the standard wording then */ });
    return () => { gone = true; };
  }, [getToken]);
  return text;
}
